// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpApIdarmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpApIdarmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpApIdarmgrIconOutlined = function DrrpApIdarmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpApIdarmgrIconOutlinedSvg
  }));
};

DrrpApIdarmgrIconOutlined.displayName = 'DrrpApIdarmgrIconOutlined';
export default React.forwardRef(DrrpApIdarmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpApIdarmgrIconOutlined.js
// module id = 2492
// module chunks = 0